import { render, staticRenderFns } from "./IceFilter.vue?vue&type=template&id=230c0267&"
import script from "./IceFilter.vue?vue&type=script&lang=js&"
export * from "./IceFilter.vue?vue&type=script&lang=js&"
import style0 from "./IceFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports